import { render, staticRenderFns } from "./DebtBalance.vue?vue&type=template&id=1462be5a&scoped=true&"
import script from "./DebtBalance.vue?vue&type=script&lang=js&"
export * from "./DebtBalance.vue?vue&type=script&lang=js&"
import style0 from "./DebtBalance.vue?vue&type=style&index=0&id=1462be5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462be5a",
  null
  
)

export default component.exports